export const INITIAL_VALUE = {
    isSelectedVideoselfieWithBiometrics: true,
    setIsSelectedVideoselfieWithBiometrics: () => {},
    isCarrouselActive: true,
};
